export default {

    computed: {
        // 操作历史
        getLogcolumns(){
			return [{
                title: this.$t('global.common.operator',{defaultValue:'操作人'}),
				key:'opUserName',
            }, 
            {
                title: this.$t('global.common.operate_type',{defaultValue:'操作类型'}),
                key: 'opAction',
                // render:(h,{row})=>{
                //     return <div>{row.carrierServiceCode} ({row.carrierCode} {row.carrierServiceName})</div>
                // }
            },
            
            {
                title: this.$t('global.common.operate_changefield',{defaultValue:'更改字段'}),
                key: 'changeField',
			},
			{
                title: this.$t('global.common.before_value',{defaultValue:'更改前值'}),
                key: 'beforeChange',
			},
			{
                title: this.$t('global.common.after_value',{defaultValue:'更改后值'}),
                key: 'afterChange',
            },
            {
                title: this.$t('global.common.operate_time',{defaultValue:'操作时间'}),
                key: 'opAt',
            },]
		}
    },
}